// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aio-landing {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.aio-landing main {
  flex: 1;
}

/* Hero */
.aio-landing .aio-hero {
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%);
  color: white;
  padding: 5rem 0 4rem;
  position: relative;
  overflow: hidden;
}

.aio-landing .aio-hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(ellipse at 30% 20%, rgba(100, 150, 255, 0.08) 0%, transparent 50%);
  pointer-events: none;
}

.aio-landing .aio-hero .container {
  position: relative;
  z-index: 1;
}

.aio-landing .aio-back-link {
  display: inline-flex;
  align-items: center;
  color: #7dd3fc;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 2rem;
  transition: color 0.3s ease, transform 0.3s ease;
}

.aio-landing .aio-back-link:hover {
  color: #38bdf8;
  transform: translateX(-4px);
}

.aio-landing .aio-hero-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.aio-landing .aio-hero-badge {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 700;
  color: #7dd3fc;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding: 0.4rem 0.9rem;
  background: rgba(125, 211, 252, 0.15);
  border-radius: 6px;
  margin-bottom: 1.5rem;
}

.aio-landing .aio-hero h1 {
  font-size: clamp(2rem, 5vw, 3.25rem);
  font-weight: 900;
  line-height: 1.15;
  margin: 0 0 1.25rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.aio-landing .aio-hero-icon {
  font-size: 1.1em;
}

.aio-landing .aio-hero-description {
  font-size: 1.15rem;
  line-height: 1.75;
  color: #cbd5e1;
  margin: 0 0 2rem;
}

.aio-landing .aio-hero-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.aio-landing .aio-hero-actions .btn-primary {
  background: linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%);
  color: #0a0a0a;
  border: none;
}

.aio-landing .aio-hero-actions .btn-primary:hover {
  background: linear-gradient(135deg, #7dd3fc 0%, #38bdf8 100%);
}

.aio-landing .aio-hero-actions .btn-secondary {
  background: transparent;
  color: #7dd3fc;
  border: 2px solid #7dd3fc;
}

.aio-landing .aio-hero-actions .btn-secondary:hover {
  background: rgba(125, 211, 252, 0.15);
  color: #bae6fd;
}

/* Sections */
.aio-landing .aio-section {
  padding: 4rem 0;
}

.aio-landing .aio-section:nth-child(even) {
  background: #f8fafc;
}

.aio-landing .aio-section h2 {
  font-size: 2.25rem;
  font-weight: 900;
  color: #0f172a;
  margin-bottom: 1rem;
  text-align: center;
}

.aio-landing .aio-section-lead {
  font-size: 1.1rem;
  line-height: 1.75;
  color: #475569;
  max-width: 720px;
  margin: 0 auto 2.5rem;
  text-align: center;
}

/* What is AIO */
.aio-landing .aio-what {
  padding-top: 3rem;
}

/* Benefits */
.aio-landing .aio-benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.aio-landing .aio-benefit-card {
  background: white;
  border-radius: 12px;
  padding: 1.75rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.3s ease, border-color 0.3s ease;
}

.aio-landing .aio-benefit-card:hover {
  border-color: #7dd3fc;
  box-shadow: 0 8px 24px rgba(14, 165, 233, 0.12);
}

.aio-landing .aio-benefit-card h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0ea5e9;
  margin-bottom: 0.75rem;
}

.aio-landing .aio-benefit-card p {
  font-size: 0.95rem;
  line-height: 1.65;
  color: #475569;
  margin: 0;
}

/* Pricing */
.aio-landing .aio-pricing {
  background: linear-gradient(180deg, #f1f5f9 0%, #fff 100%);
}

.aio-landing .aio-pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
  align-items: stretch;
}

.aio-landing .aio-pricing-card {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  border: 2px solid #e2e8f0;
  position: relative;
  display: flex;
  flex-direction: column;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.aio-landing .aio-pricing-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);
}

.aio-landing .aio-pricing-card-featured {
  border-color: #0ea5e9;
  box-shadow: 0 12px 32px rgba(14, 165, 233, 0.2);
}

.aio-landing .aio-pricing-card-featured:hover {
  border-color: #0284c7;
  box-shadow: 0 16px 40px rgba(14, 165, 233, 0.25);
}

.aio-landing .aio-pricing-badge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: white;
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  padding: 0.35rem 0.75rem;
  border-radius: 20px;
}

.aio-landing .aio-pricing-name {
  font-size: 1.5rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 0.5rem;
}

.aio-landing .aio-pricing-price {
  margin-bottom: 0.75rem;
}

.aio-landing .aio-pricing-amount {
  font-size: 2.25rem;
  font-weight: 900;
  color: #0f172a;
}

.aio-landing .aio-pricing-period {
  font-size: 1rem;
  font-weight: 600;
  color: #64748b;
}

.aio-landing .aio-pricing-desc {
  font-size: 0.95rem;
  line-height: 1.5;
  color: #475569;
  margin: 0 0 0.5rem;
}

.aio-landing .aio-pricing-best {
  font-size: 0.85rem;
  color: #64748b;
  font-style: italic;
  margin: 0 0 1.25rem;
}

.aio-landing .aio-pricing-features {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem;
  flex: 1;
}

.aio-landing .aio-pricing-features li {
  font-size: 0.95rem;
  color: #334155;
  padding: 0.4rem 0;
  padding-left: 1.5rem;
  position: relative;
  line-height: 1.4;
}

.aio-landing .aio-pricing-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #0ea5e9;
  font-weight: 700;
}

.aio-landing .aio-pricing-cta {
  display: block;
  text-align: center;
  padding: 0.9rem 1.25rem;
  font-weight: 700;
  text-decoration: none;
  border-radius: 8px;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.aio-landing .aio-pricing-cta:hover {
  opacity: 0.95;
  transform: translateY(-1px);
}

.aio-landing .aio-pricing-card-featured .aio-pricing-cta {
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  color: white;
  border: none;
}

.aio-landing .aio-pricing-note {
  font-size: 0.9rem;
  color: #64748b;
  text-align: center;
  max-width: 640px;
  margin: 2.5rem auto 0;
  line-height: 1.6;
}

/* FAQ — semantic dl/dt/dd for LLM-friendly Q&A */
.aio-landing .aio-faq-list {
  list-style: none;
  padding: 0;
  margin: 2rem auto 0;
  max-width: 720px;
}

.aio-landing .aio-faq-item {
  border-bottom: 1px solid #e2e8f0;
  padding: 1.25rem 0;
}

.aio-landing .aio-faq-item:last-child {
  border-bottom: none;
}

.aio-landing .aio-faq-question {
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.5rem;
}

.aio-landing .aio-faq-answer {
  font-size: 1rem;
  line-height: 1.7;
  color: #475569;
  margin: 0;
  padding-left: 0;
}

.aio-landing .aio-definition {
  font-weight: 600;
  color: #0f172a;
}

/* Process */
.aio-landing .aio-process-steps {
  max-width: 640px;
  margin: 2rem auto 0;
}

.aio-landing .aio-process-step {
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
  padding: 1.5rem 0;
  border-bottom: 1px solid #e2e8f0;
}

.aio-landing .aio-process-step:last-child {
  border-bottom: none;
}

.aio-landing .aio-process-num {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 800;
  flex-shrink: 0;
}

.aio-landing .aio-process-step h3 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.35rem;
}

.aio-landing .aio-process-step p {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #475569;
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .aio-landing .aio-hero {
    padding: 3.5rem 0 3rem;
  }

  .aio-landing .aio-hero h1 {
    flex-direction: column;
  }

  .aio-landing .aio-section {
    padding: 3rem 0;
  }

  .aio-landing .aio-section h2 {
    font-size: 1.85rem;
  }

  .aio-landing .aio-pricing-grid {
    grid-template-columns: 1fr;
  }

  .aio-landing .aio-process-step {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .aio-landing .aio-process-num {
    margin: 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/aio/AIOLandingPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA,SAAS;AACT;EACE,0EAA0E;EAC1E,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8FAA8F;EAC9F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;EACzC,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,6DAA6D;EAC7D,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".aio-landing {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.aio-landing main {\n  flex: 1;\n}\n\n/* Hero */\n.aio-landing .aio-hero {\n  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%);\n  color: white;\n  padding: 5rem 0 4rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.aio-landing .aio-hero::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(ellipse at 30% 20%, rgba(100, 150, 255, 0.08) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.aio-landing .aio-hero .container {\n  position: relative;\n  z-index: 1;\n}\n\n.aio-landing .aio-back-link {\n  display: inline-flex;\n  align-items: center;\n  color: #7dd3fc;\n  text-decoration: none;\n  font-weight: 600;\n  margin-bottom: 2rem;\n  transition: color 0.3s ease, transform 0.3s ease;\n}\n\n.aio-landing .aio-back-link:hover {\n  color: #38bdf8;\n  transform: translateX(-4px);\n}\n\n.aio-landing .aio-hero-content {\n  max-width: 800px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.aio-landing .aio-hero-badge {\n  display: inline-block;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #7dd3fc;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  padding: 0.4rem 0.9rem;\n  background: rgba(125, 211, 252, 0.15);\n  border-radius: 6px;\n  margin-bottom: 1.5rem;\n}\n\n.aio-landing .aio-hero h1 {\n  font-size: clamp(2rem, 5vw, 3.25rem);\n  font-weight: 900;\n  line-height: 1.15;\n  margin: 0 0 1.25rem;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.aio-landing .aio-hero-icon {\n  font-size: 1.1em;\n}\n\n.aio-landing .aio-hero-description {\n  font-size: 1.15rem;\n  line-height: 1.75;\n  color: #cbd5e1;\n  margin: 0 0 2rem;\n}\n\n.aio-landing .aio-hero-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.aio-landing .aio-hero-actions .btn-primary {\n  background: linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%);\n  color: #0a0a0a;\n  border: none;\n}\n\n.aio-landing .aio-hero-actions .btn-primary:hover {\n  background: linear-gradient(135deg, #7dd3fc 0%, #38bdf8 100%);\n}\n\n.aio-landing .aio-hero-actions .btn-secondary {\n  background: transparent;\n  color: #7dd3fc;\n  border: 2px solid #7dd3fc;\n}\n\n.aio-landing .aio-hero-actions .btn-secondary:hover {\n  background: rgba(125, 211, 252, 0.15);\n  color: #bae6fd;\n}\n\n/* Sections */\n.aio-landing .aio-section {\n  padding: 4rem 0;\n}\n\n.aio-landing .aio-section:nth-child(even) {\n  background: #f8fafc;\n}\n\n.aio-landing .aio-section h2 {\n  font-size: 2.25rem;\n  font-weight: 900;\n  color: #0f172a;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.aio-landing .aio-section-lead {\n  font-size: 1.1rem;\n  line-height: 1.75;\n  color: #475569;\n  max-width: 720px;\n  margin: 0 auto 2.5rem;\n  text-align: center;\n}\n\n/* What is AIO */\n.aio-landing .aio-what {\n  padding-top: 3rem;\n}\n\n/* Benefits */\n.aio-landing .aio-benefits-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.5rem;\n  margin-top: 2rem;\n}\n\n.aio-landing .aio-benefit-card {\n  background: white;\n  border-radius: 12px;\n  padding: 1.75rem;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n.aio-landing .aio-benefit-card:hover {\n  border-color: #7dd3fc;\n  box-shadow: 0 8px 24px rgba(14, 165, 233, 0.12);\n}\n\n.aio-landing .aio-benefit-card h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0ea5e9;\n  margin-bottom: 0.75rem;\n}\n\n.aio-landing .aio-benefit-card p {\n  font-size: 0.95rem;\n  line-height: 1.65;\n  color: #475569;\n  margin: 0;\n}\n\n/* Pricing */\n.aio-landing .aio-pricing {\n  background: linear-gradient(180deg, #f1f5f9 0%, #fff 100%);\n}\n\n.aio-landing .aio-pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.5rem;\n  margin-top: 2rem;\n  align-items: stretch;\n}\n\n.aio-landing .aio-pricing-card {\n  background: white;\n  border-radius: 16px;\n  padding: 2rem;\n  border: 2px solid #e2e8f0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.aio-landing .aio-pricing-card:hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);\n}\n\n.aio-landing .aio-pricing-card-featured {\n  border-color: #0ea5e9;\n  box-shadow: 0 12px 32px rgba(14, 165, 233, 0.2);\n}\n\n.aio-landing .aio-pricing-card-featured:hover {\n  border-color: #0284c7;\n  box-shadow: 0 16px 40px rgba(14, 165, 233, 0.25);\n}\n\n.aio-landing .aio-pricing-badge {\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: white;\n  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);\n  padding: 0.35rem 0.75rem;\n  border-radius: 20px;\n}\n\n.aio-landing .aio-pricing-name {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0 0 0.5rem;\n}\n\n.aio-landing .aio-pricing-price {\n  margin-bottom: 0.75rem;\n}\n\n.aio-landing .aio-pricing-amount {\n  font-size: 2.25rem;\n  font-weight: 900;\n  color: #0f172a;\n}\n\n.aio-landing .aio-pricing-period {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.aio-landing .aio-pricing-desc {\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: #475569;\n  margin: 0 0 0.5rem;\n}\n\n.aio-landing .aio-pricing-best {\n  font-size: 0.85rem;\n  color: #64748b;\n  font-style: italic;\n  margin: 0 0 1.25rem;\n}\n\n.aio-landing .aio-pricing-features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 1.5rem;\n  flex: 1;\n}\n\n.aio-landing .aio-pricing-features li {\n  font-size: 0.95rem;\n  color: #334155;\n  padding: 0.4rem 0;\n  padding-left: 1.5rem;\n  position: relative;\n  line-height: 1.4;\n}\n\n.aio-landing .aio-pricing-features li::before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  color: #0ea5e9;\n  font-weight: 700;\n}\n\n.aio-landing .aio-pricing-cta {\n  display: block;\n  text-align: center;\n  padding: 0.9rem 1.25rem;\n  font-weight: 700;\n  text-decoration: none;\n  border-radius: 8px;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.aio-landing .aio-pricing-cta:hover {\n  opacity: 0.95;\n  transform: translateY(-1px);\n}\n\n.aio-landing .aio-pricing-card-featured .aio-pricing-cta {\n  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);\n  color: white;\n  border: none;\n}\n\n.aio-landing .aio-pricing-note {\n  font-size: 0.9rem;\n  color: #64748b;\n  text-align: center;\n  max-width: 640px;\n  margin: 2.5rem auto 0;\n  line-height: 1.6;\n}\n\n/* FAQ — semantic dl/dt/dd for LLM-friendly Q&A */\n.aio-landing .aio-faq-list {\n  list-style: none;\n  padding: 0;\n  margin: 2rem auto 0;\n  max-width: 720px;\n}\n\n.aio-landing .aio-faq-item {\n  border-bottom: 1px solid #e2e8f0;\n  padding: 1.25rem 0;\n}\n\n.aio-landing .aio-faq-item:last-child {\n  border-bottom: none;\n}\n\n.aio-landing .aio-faq-question {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.5rem;\n}\n\n.aio-landing .aio-faq-answer {\n  font-size: 1rem;\n  line-height: 1.7;\n  color: #475569;\n  margin: 0;\n  padding-left: 0;\n}\n\n.aio-landing .aio-definition {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n/* Process */\n.aio-landing .aio-process-steps {\n  max-width: 640px;\n  margin: 2rem auto 0;\n}\n\n.aio-landing .aio-process-step {\n  display: flex;\n  gap: 1.5rem;\n  align-items: flex-start;\n  padding: 1.5rem 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.aio-landing .aio-process-step:last-child {\n  border-bottom: none;\n}\n\n.aio-landing .aio-process-num {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.aio-landing .aio-process-step h3 {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.35rem;\n}\n\n.aio-landing .aio-process-step p {\n  font-size: 0.95rem;\n  line-height: 1.6;\n  color: #475569;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .aio-landing .aio-hero {\n    padding: 3.5rem 0 3rem;\n  }\n\n  .aio-landing .aio-hero h1 {\n    flex-direction: column;\n  }\n\n  .aio-landing .aio-section {\n    padding: 3rem 0;\n  }\n\n  .aio-landing .aio-section h2 {\n    font-size: 1.85rem;\n  }\n\n  .aio-landing .aio-pricing-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .aio-landing .aio-process-step {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n\n  .aio-landing .aio-process-num {\n    margin: 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
